module.exports = __webpack_public_path__ + "img/img95.699pic.470f018f.png";